








































# import settings from '@/settings'
import n from '@/utils/notifications'
import m from '@/graphql/mutation'
import Menus from '@/components/menus'

export default {
    name: 'users_account'
    components: {
            Menus
    }

    data: ()->
        errors: {}
        email: @$store.state.user_datas.app_user.email
        password: ''
        password_confirm: ''

    methods:
        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        save: ()->
            # console.log "ACCOUNT SAVE"
            self = @
            m.run('save_account', [@$store.state.user_datas.app_user.uid, @email, @password, @password_confirm])
            .then (resp)->
                # console.log "ACCOUNT MUTATION RESPONSE", resp.body.data.account_form_mutation
                if resp.body.data.account_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.account_form_mutation.errors
                    self.errors = resp.body.data.account_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    user_datas = self.$store.state.user_datas
                    user_datas.app_user.email = self.email
                    self.$store.commit('set_user_datas', user_datas)
                    n.success()
            .catch (resp)->
                n.catch_error(resp, "users_account: save()")            
}
